import React from "react";

import _ from "lodash";
import PropTypes from "prop-types";
import ReactDOMServer from "react-dom/server";
import { FormattedMessage } from "react-intl";

import { getExternalAddress } from "../../../lib/url_utils";

import { CopyEmbedScript } from "./host-embed-copy-component";

const embedlyStyling =
  ".card{font-family:Avenir,serif}.card .title{margin-top:16px;font-size:18px;font-weight:400!important}.card .action{margin-top:16px;color:#ef4365;font-size:0;content:''}.card .action:before{font-size:18px;content:'Book now on Peerspace';margin-top:12px}.card .action:after{position:relative;top:0;font-size:24px;content:\" →\"}.card .action:hover{color:#bd2446}.card .social{display:none}.card .provider-name{text-transform:lowercase!important;letter-spacing:2px;font-weight:400!important}.card .provider .author{display: none}";
const HostEmbedCode = ({ listingURL, listingTitle, isPreview }) => {
  return (
    <div id="ps-embedly-card">
      <style
        className="embedly-css"
        dangerouslySetInnerHTML={{ __html: embedlyStyling }}
      />
      <blockquote
        className="embedly-card"
        data-card-key="793a068f28534777859f8f55dd0d881a"
        data-card-type="article-full"
        data-card-width="330px"
        data-card-controls="0"
      >
        <h4>
          <a href={listingURL}>{listingTitle}</a>
        </h4>
      </blockquote>
      {!isPreview ? (
        <script
          async
          src="//cdn.embedly.com/widgets/platform.js"
          charSet="UTF-8"
        />
      ) : null}
    </div>
  );
};

HostEmbedCode.propTypes = {
  listingURL: PropTypes.string,
  listingTitle: PropTypes.string,
  isPreview: PropTypes.bool,
};

const makeListingURL = (utmHash, listingID) => {
  const UTMs = _.chain(utmHash)
    .toPairs()
    .map((kv) => {
      const z = kv.join("=");
      return z;
    })
    .join("&")
    .value();
  const URL = `${getExternalAddress()}/pages/listings/${listingID}?${UTMs}`;
  return URL;
};

export const HostEmbedPage = ({
  listingDetails,
  hostThumbnailEmbeds,
  postCopyAction,
}) => {
  const { _id: listingID, title: listingTitle } = listingDetails;
  const { external, preview } = hostThumbnailEmbeds;

  const codeSnippetProps = {
    listingTitle,
    listingURL: makeListingURL(external, listingID),
  };

  const thumbnailPreviewProps = {
    listingTitle,
    listingURL: makeListingURL(preview, listingID),
    isPreview: true,
  };

  const codeSnippet = ReactDOMServer.renderToStaticMarkup(
    <HostEmbedCode {...codeSnippetProps} />,
  );

  const previewSheathStyle = {
    height: "330px",
    position: "absolute",
    zIndex: "2",
    width: "100%",
  };

  return (
    <div
      id="host-embed-page"
      className="HostEmbedPage ps-container-lg-margin ps-container-fixed"
    >
      <div className="ps-row">
        <h2 className="col-xs-12" style={{ marginTop: "48px" }}>
          <FormattedMessage
            id="hosting.host_embed_page.embed_listing_heading"
            defaultMessage="Embed your listing"
          />
        </h2>
        <p className="col-xs-12">
          <FormattedMessage
            id="hosting.host_embed_page.copy_code_text"
            defaultMessage="Promote your listing on your website by copying the code:"
          />
        </p>
      </div>
      <div className="ps-row">
        <div
          className="col-xs-12 col-sm-6"
          id="thumbnail-code"
          style={{ margin: "24px auto" }}
        >
          <div id={`embed-for-${listingID}`}>
            <CopyEmbedScript
              snippet={codeSnippet}
              postCopyAction={postCopyAction}
            />
          </div>
        </div>
        <div className="col-xs-12 col-sm-6">
          <label
            htmlFor="thumbnail-preview"
            className="col-xs-12 col-sm-10 col-sm-offset-2"
            style={{ padding: "0" }}
          >
            <FormattedMessage
              id="hosting.host_embed_page.preview_label"
              defaultMessage="Preview"
            />
          </label>
          <div id="thumbnail-sheath" style={previewSheathStyle} />
          <div
            id="thumbnail-preview"
            className="col-xs-12 col-sm-10 col-sm-offset-2 thumbnail-preview"
          >
            <HostEmbedCode {...thumbnailPreviewProps} />
          </div>
        </div>
      </div>
    </div>
  );
};

HostEmbedPage.propTypes = {
  listingDetails: PropTypes.object,
  hostThumbnailEmbeds: PropTypes.object,
  postCopyAction: PropTypes.func,
};
